import { useState } from 'react';
import Image from '../image/Image';
import logoutImage from './assets/log-out.png';
import { useOutsideClick } from '../../hooks/useOutsideClick';
import './UserDropdown.scss';

type Props = {
    username: string;
    onLogout: () => void;
};

export const UserDropdown = ({ username, onLogout }: Props) => {
    const [ open, setOpen ] = useState(false);
    const ref = useOutsideClick<HTMLDivElement>(() => setOpen(false));

    return (
        <div className="userDropdown" ref={ref}>
            <button
                onClick={() => setOpen((prev) => !prev)}
                className="userDropdown_username"
            >
                {username} ⏷
            </button>

            {open && (
                <div className="userDropdown_actionsContainer">
                    <div
                        className="userDropdown_actionsContainer_actionItem"
                        onClick={() => {
                            onLogout();
                            setOpen(false);
                        }}
                    >
                        <Image src={logoutImage} alt="logout"/>
                        <span>Logout</span>
                    </div>
                </div>
            )}
        </div>
    );
};